import { render } from "./ProfileTeacherBase.vue?vue&type=template&id=cc332f46&scoped=true"
import script from "./ProfileTeacherBase.vue?vue&type=script&lang=js"
export * from "./ProfileTeacherBase.vue?vue&type=script&lang=js"

import "./ProfileTeacherBase.vue?vue&type=style&index=0&id=cc332f46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc332f46"]])

export default __exports__